import Vue from 'vue'
import Router from 'vue-router'
import {
  passList
} from '@/utils/global'
import store from '@/store'
let vm = new Vue()
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/manager/login',
      name: '登录',
      component: () => import('@/views/login')
    },
    {
      path: '/manager/home',
      name: '主页',
      component: () => import("@/components/layout"),
      children: [{
        path: '/manager/index'
      }]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (passList.includes(to.path)) {
    // 无权限可以访问的页面
    next()
  } else if (store.getters.access_token) {
    if (store.getters.roles.length === 0) {
      let p1 = store.dispatch('getUserInfo')
      let p2 = store.dispatch('getMenuList', {
        id: -1
      })
      store.dispatch('getAllDict')

      Promise.all([p1, p2])
        .then(([result1, result2]) => {
          vm.$formatRoutes(result2)
          if (to.path === '/manager/index') {
            next(store.getters.firstUrl)
          } else {
            next(to.path)
          }
        })
    } else if (store.getters.roles.length > 0) {
      next()
    }
  } else {
    next('/manager/login')
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js